// src/ColdBlockContacts.jsx
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './styles/ColdBlockContacts.css';
import { Link } from 'react-router-dom';

const ColdBlockContacts = ({
  ColdBlockContacts = [
    {
      email: 'kmoffatt@coldblock.ca',
      name: 'Kathy Moffatt, VP, Sales <br /> ColdBlock Technologies Inc.',
    },
    {
      email: 'ladoig@coldblock.ca',
      name: 'Lorie-Anne Doig, Director, Laboratory Services <br /> ColdBlock Technologies Inc.',
    },
    {
      email: 'mpalomba@coldblock.ca',
      name: 'Matthew Palomba, Laboratory Analyst <br /> ColdBlock Technologies Inc.',
    },
  ],
  BVContacts = [
    {
      email: 'michael.dunning@bureauveritas.com',
      name: 'Michael Dunning, Minerals Technical and Quality Director <br /> Bureau Veritas',
    },
    {
      email: 'ielisson.amorim@bureauveritas.com',
      name: 'Ielisson Mello de Amorim, Group Procurement Director <br /> Bureau Veritas',
    },
  ],
}) => {
  return (
    <section className="cb-contacts pb-4 pb-md-5">
      <Container>
        <Row className="gy-5 justify-content-start text-center mb-5">
          <h2 className="contact-title">Important Contacts</h2>
          <Container className="cb-help mt-3">
            <Row className="align-items-center g-3 justify-content-center text-center text-md-start">
              <Col md="10">
                <p className="mb-0 cb-help" style={{ textAlign: 'center' }} >
                  For assistance with sample testing, method optimization, more
                  information on a sample type, or the transition from current
                  digestion processes, please contact:
                </p>
              </Col>
            </Row>
          </Container>
          <Row className="mt-4 pt-4">
            <Col md="6" className="d-flex flex-column align-items-center">
              <h3 className="cb-heading">ColdBlock Contacts</h3>
              {ColdBlockContacts?.map((c, i) => (
                <div key={i}>
                  <i className="mdi mdi-email cb-email-icon mb-2" />
                  <div>
                    <a href={`mailto:${c.email}`} className="cb-email">
                      {c.email}
                    </a>
                  </div>
                  <div className="cb-contact-name mt-1">{c.name && <span dangerouslySetInnerHTML={{ __html: c.name }} />}</div>
                </div>
              ))}
            </Col>
            <Col md="6" className="d-flex flex-column align-items-center mt-4 mt-md-0 pt-4 pt-md-0">
              <h3 className="cb-heading">BV Contacts</h3>
              {BVContacts?.map((c, i) => (
                <div key={i}>
                  <i className="mdi mdi-email cb-email-icon mb-2" />
                  <div>
                    <a href={`mailto:${c.email}`} className="cb-email">
                      {c.email}
                    </a>
                  </div>
                  <div className="cb-contact-name mt-1">{c.name && <span dangerouslySetInnerHTML={{ __html: c.name }} />}</div>
                </div>
              ))}
            </Col>
          </Row>
        </Row>

        <Row className="gy-5 justify-content-center text-center mt-4">
          <Col md="6">
            <h4 className="cb-heading mb-2">
              <Link to="/resources" className="cb-heading">
                Overview of Resources Available
              </Link>
            </h4>
            <p className="cb-p">
              To view the list of resources available in this portal, please
              visit <Link to="/resources" className="cb-link"> our Resources Directory.</Link>
            </p>
          </Col>
          <Col md="6">
            <h4 className="cb-heading mb-2">How to Order and Access Support</h4>
            <p className="cb-p">
              For assistance or questions, please contact{' '}
              <a href="mailto:info@coldblock.ca" className="cb-link">info@coldblock.ca</a>.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ColdBlockContacts;
